import { useEffect } from 'react'
import classNames from 'classnames'
import { ChevronRightIcon, CloseIcon } from '../../icons'

export type ShopTheLookProduct = {
  id: number
  title: string
  url: string
  image: string
  priceText: string
}

type Props = {
  isOpen: boolean
  products: ShopTheLookProduct[]
  onClose: () => void
  className?: string
  /* Off when the host's own toggle turns into the close button. */
  showClose?: boolean
}

const ShopTheLookDrawer = ({ isOpen, products, onClose, className, showClose = true }: Props) => {
  useEffect(() => {
    if (!isOpen) return

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }

    document.addEventListener('keydown', onKeyDown)
    return () => document.removeEventListener('keydown', onKeyDown)
  }, [isOpen, onClose])

  return (
    <div className={classNames('ShopTheLookDrawer', isOpen && 'is-open', className)}>
      {showClose && (
        <button type="button" className="ShopTheLookDrawer__Close" tabIndex={isOpen ? 0 : -1} onClick={onClose}>
          <CloseIcon />
        </button>
      )}
      <ul className="ShopTheLookDrawer__List">
        {products.map((product) => (
          <li className="ShopTheLookDrawer__Item" key={product.id}>
            <a className="ShopTheLookDrawer__Product" href={product.url} tabIndex={isOpen ? 0 : -1}>
              <span className="ShopTheLookDrawer__Thumb">{product.image && <img src={product.image} alt={product.title} loading="lazy" />}</span>
              <span className="ShopTheLookDrawer__Details">
                <span className="ShopTheLookDrawer__Title font-bstSpyre font-light uppercase">{product.title}</span>
                <span className="ShopTheLookDrawer__Price font-calibre font-light">{product.priceText}</span>
              </span>
              <span className="ShopTheLookDrawer__Chevron">
                <ChevronRightIcon />
              </span>
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ShopTheLookDrawer
